<ng-container *ngIf="isLoading; else pageContent">
  <div class="auth-spinner">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <div class="auth-wrap">

    <div class="auth-left">
      <div>
        <a routerLink="/" class="auth-logo-row">
          <img src="assets/images/BeExpert-logo (3).svg" alt="BeExpert" class="auth-logo-img" />
        </a>

        <div class="auth-step-pill">Step 2 of 5 — Verify number</div>

        <h1 class="auth-left-h1">You're almost in.<br>Just one more<br>quick step.</h1>
        <p class="auth-left-sub">
          We've sent a 6-digit OTP to your mobile via SMS.
          Enter it below to secure your account.
        </p>

        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          OTP sent via SMS to your number
        </div>
        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          Valid for 2 minutes
        </div>
        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          Your number is never shared with anyone
        </div>

        <div class="auth-ill-cards">
          <div class="auth-ill-card">
            <div class="auth-ill-icon text-white">
				<i class="bi bi-envelope-paper"></i>
			</div>
            <div>
              <span class="auth-ill-title">SMS Sent</span>
              <span class="auth-ill-sub">Your OTP: ● ● ● ● ● ●  · Just now</span>
            </div>
          </div>
          <div class="auth-ill-card">
            <div class="auth-ill-icon text-white">
				<i class="bi bi-bullseye"></i>
			</div>
            <div>
              <span class="auth-ill-title">After verification</span>
              <span class="auth-ill-sub">Get your readiness score in 2 minutes</span>
            </div>
          </div>
        </div>
      </div>

      <div class="auth-stats-bar">
        <div class="auth-stat-col">
          <span class="auth-stat-num">10K+</span>
          <span class="auth-stat-lbl">Active students</span>
        </div>
        <div class="auth-stat-col">
          <span class="auth-stat-num">Free</span>
          <span class="auth-stat-lbl">To get started</span>
        </div>
        <div class="auth-stat-col">
          <span class="auth-stat-num">5 min</span>
          <span class="auth-stat-lbl">To your score</span>
        </div>
      </div>
    </div>

    <div class="auth-right">
      <a routerLink="/" class="auth-mobile-bar">
        <img src="assets/images/beExpert.svg" alt="BeExpert" />
                <span class="mt-1 beexpert">BeExpert</span>
      </a>
      <div class="auth-form-box">

        <div class="auth-form-title">Enter OTP</div>
        <div class="auth-form-sub">
          6-digit code sent via SMS to
          <strong>+91 {{ phone_number }}</strong>
        </div>

        <form [formGroup]="mobileForm">

          <div class="auth-field">
            <label class="auth-label">Enter 6-digit OTP</label>
            <div class="otp-row" formArrayName="otp">
              <input
                *ngFor="let ctrl of otpControls.controls; let i = index"
                [formControlName]="i"
                class="otp-box"
                maxlength="1"
                type="text"
                inputmode="numeric"
                autocomplete="one-time-code"
                #otpInput
                (input)="onOtpInput($event, i)"
                (keydown)="onOtpKeyDown($event, i)"
                (paste)="onOtpPaste($event)"
              />
            </div>
          </div>

          <p class="auth-resend">
            Didn't receive it?
            <span
              class="auth-resend__link"
              [class.auth-resend__link--disabled]="resendCooldown > 0"
              (click)="resendOtp()"
            >
              <ng-container *ngIf="resendCooldown === 0">Resend OTP</ng-container>
              <ng-container *ngIf="resendCooldown > 0">Resend in {{ resendCooldown }}s</ng-container>
            </span>
          </p>

          <button
            type="button"
            class="auth-submit"
            (click)="verifyOtp()"
            [disabled]="!isOtpValid()"
          >
            Verify &amp; Continue →
          </button>

        </form>

        <div class="change-num" (click)="editPhoneNumber()">← Change mobile number</div>

        <div class="security-note">
          <span style="font-size:18px">
			<i class="bi bi-lock"></i>
		  </span>
          <div class="security-note-text">
            Your phone number is used only for login. We'll send placement prep updates
            and notifications via WhatsApp — you can opt out any time.
          </div>
        </div>

        <p class="auth-footer-link">
          Already have an account? <a routerLink="/login">Sign in</a>
        </p>

      </div>
    </div>

  </div>
</ng-template>
